import {
  PATH_LOGIN,
  PATH_NOT_FOUND,
  PATH_403,
  PATH_NO_DD,
  PATH_NOPC
} from "@/constants/URL";
export default [
  {
    path: PATH_LOGIN,
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/index.vue")
  },
  {
    path: PATH_403,
    component: () =>
      import(/* webpackChunkName: "403_page" */ "@/views/403.vue")
  },
  {
    path: PATH_NOT_FOUND,
      component: () =>
        import(/* webpackChunkName: "notfound" */ "@/views/404.vue")
    },
  {
    path: PATH_NOPC,
    component: () =>
      import(/* webpackChunkName: "notfound" */ "@/views/nopc.vue")
  },
  {
    path: PATH_NO_DD,
    component: () =>
      import(/* webpackChunkName: "notfound" */ "@/views/nodd.vue")
  },
  {
    path: "*",
    name: "notfound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "@/views/404.vue")
  }
];
